<template>
  <b-modal
    v-model="modal"
    class="position-relative"
    lazy
    centered
    body-class="py-5"
    content-class="new-section-modal"
    size="lg"
    hide-footer
    hide-header
  >
    <h3 class="text-center font-weight-bold mb-12 px-0">
      {{ folder ? 'Edit' : 'Create New' }} Folder
    </h3>

    <b-row>
      <b-col
        offset="2"
        cols="8"
      >
        <b-form @submit.prevent="submit">
          <b-form-group
            class="estage-form-group"
            label="Enter Folder Name"
          >
            <b-input
              v-model="name"
              v-validate="'required'"
              name="name"
              :state="errors.has('name') ? false : null"
            />
          </b-form-group>

          <div class="text-center mt-5">
            <b-btn
              type="submit"
              variant="primary"
              class="font-weight-bold font-size-14 px-5"
              :disabled="loading"
            >
              {{ folder ? 'Update' : 'Create' }}
              <b-spinner
                v-if="loading"
                class="mr-2"
                variant="light"
                small
              />
            </b-btn>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'GlobalVariableFolderManage',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    folder: {
      type: [Object, null],
      required: false,
      default: null
    }
  },
  computed: {
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      name: '',
      loading: false
    }
  },
  watch: {
    modal (val) {
      if (val) {
        if (this.folder) {
          this.name = this.folder.name
        } else {
          this.name = ''
        }
        this.loading = false
      }
    }
  },
  methods: {
    submit () {
      if (this.folder) {
        this.$emit('update', this.folder, this.name)
      } else {
        this.$emit('create', this.name)
      }
      this.modal = false
    }
  }
}
</script>
